export * from './iconFontAwesomeBuildingsHouse';
export * from './iconFontAwesomeBuildingsCity';
export * from './iconFontAwesomeBuildingsShop';
export * from './iconFontAwesomeBuildingsLandmark';
export * from './iconFontAwesomeBuildingsBuilding';
export * from './iconFontAwesomeBuildingsStore';
export * from './iconFontAwesomeBuildingsSchool';
export * from './iconFontAwesomeBuildingsHotel';
export * from './iconFontAwesomeBuildingsPlaceOfWorship';
export * from './iconFontAwesomeBuildingsHospital';
export * from './iconFontAwesomeBuildingsChurch';
export * from './iconFontAwesomeBuildingsWarehouse';
export * from './iconFontAwesomeBuildingsGopuram';
export * from './iconFontAwesomeBuildingsIndustry';
export * from './iconFontAwesomeBuildingsVihara';
export * from './iconFontAwesomeBuildingsTreeCity';
export * from './iconFontAwesomeBuildingsTowerObservation';
export * from './iconFontAwesomeBuildingsToriiGate';
export * from './iconFontAwesomeBuildingsToiletsPortable';
export * from './iconFontAwesomeBuildingsToiletPortable';
export * from './iconFontAwesomeBuildingsTents';
export * from './iconFontAwesomeBuildingsTentArrowsDown';
export * from './iconFontAwesomeBuildingsTentArrowTurnLeft';
export * from './iconFontAwesomeBuildingsTentArrowLeftRight';
export * from './iconFontAwesomeBuildingsTentArrowDownToLine';
export * from './iconFontAwesomeBuildingsTent';
export * from './iconFontAwesomeBuildingsSynagogue';
export * from './iconFontAwesomeBuildingsShopLock';
export * from './iconFontAwesomeBuildingsSchoolLock';
export * from './iconFontAwesomeBuildingsSchoolFlag';
export * from './iconFontAwesomeBuildingsSchoolCircleXmark';
export * from './iconFontAwesomeBuildingsSchoolCircleExclamation';
export * from './iconFontAwesomeBuildingsSchoolCircleCheck';
export * from './iconFontAwesomeBuildingsOilWell';
export * from './iconFontAwesomeBuildingsMountainCity';
export * from './iconFontAwesomeBuildingsMosque';
export * from './iconFontAwesomeBuildingsMonument';
export * from './iconFontAwesomeBuildingsLandmarkFlag';
export * from './iconFontAwesomeBuildingsLandmarkDome';
export * from './iconFontAwesomeBuildingsKaaba';
export * from './iconFontAwesomeBuildingsIgloo';
export * from './iconFontAwesomeBuildingsHouseMedicalFlag';
export * from './iconFontAwesomeBuildingsHouseMedicalCircleXmark';
export * from './iconFontAwesomeBuildingsHouseMedicalCircleExclamation';
export * from './iconFontAwesomeBuildingsHouseMedicalCircleCheck';
export * from './iconFontAwesomeBuildingsHouseMedical';
export * from './iconFontAwesomeBuildingsHouseLock';
export * from './iconFontAwesomeBuildingsHouseFlag';
export * from './iconFontAwesomeBuildingsHouseFire';
export * from './iconFontAwesomeBuildingsHouseCrack';
export * from './iconFontAwesomeBuildingsHouseCircleXmark';
export * from './iconFontAwesomeBuildingsHouseCircleExclamation';
export * from './iconFontAwesomeBuildingsHouseCircleCheck';
export * from './iconFontAwesomeBuildingsHouseChimneyWindow';
export * from './iconFontAwesomeBuildingsHouseChimneyMedical';
export * from './iconFontAwesomeBuildingsHouseChimneyCrack';
export * from './iconFontAwesomeBuildingsHouseChimney';
export * from './iconFontAwesomeBuildingsHospitalUser';
export * from './iconFontAwesomeBuildingsDungeon';
export * from './iconFontAwesomeBuildingsCampground';
export * from './iconFontAwesomeBuildingsBuildingWheat';
export * from './iconFontAwesomeBuildingsBuildingUser';
export * from './iconFontAwesomeBuildingsBuildingUn';
export * from './iconFontAwesomeBuildingsBuildingShield';
export * from './iconFontAwesomeBuildingsBuildingNgo';
export * from './iconFontAwesomeBuildingsBuildingLock';
export * from './iconFontAwesomeBuildingsBuildingFlag';
export * from './iconFontAwesomeBuildingsBuildingColumns';
export * from './iconFontAwesomeBuildingsBuildingCircleXmark';
export * from './iconFontAwesomeBuildingsBuildingCircleExclamation';
export * from './iconFontAwesomeBuildingsBuildingCircleCheck';
export * from './iconFontAwesomeBuildingsBuildingCircleArrowRight';
export * from './iconFontAwesomeBuildingsArrowRightToCity';
export * from './iconFontAwesomeBuildingsArchway';
